import React from 'react';

import './styles.scss';
import Icon from '../icon';
import {Icons} from '../../util/icons';
import colors from '../../util/colors';
import {createClassName} from '../../util/utility';
import {trackButtonClick} from '../../util/appInsights';
import {useTelemetrySection} from '../../util/TelemetrySection';

interface AppArrowButtonProps {
  color?: string;
  onClick(): void;
  className?: string;
  direction?: 'LEFT' | 'RIGHT';
  disabled?: boolean;
  telemetryId?: string;
  telemetryLabel?: string;
  telemetrySection?: string;
  telemetryCategory?: string;
}

function AppArrowButton({
  onClick,
  className,
  color = colors.black,
  direction = 'RIGHT',
  disabled = false,
  telemetryId,
  telemetryLabel,
  telemetrySection,
  telemetryCategory,
}: AppArrowButtonProps) {
  const classes = createClassName('app-arrow-button', className);
  const contextSection = useTelemetrySection();
  const activeSection = telemetrySection || contextSection;

  const rotate = direction === 'RIGHT' && {transform: 'rotate(180deg)'};

  const currentColor = disabled ? colors.lightGrey : color;

  const handleClick = () => {
    if (disabled) return;

    trackButtonClick(
      telemetryLabel || `arrow_${direction.toLowerCase()}`,
      telemetryCategory || 'Navigation',
      { direction },
      telemetryId,
      activeSection
    );

    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      className={classes}
      style={{borderColor: currentColor, ...rotate}}
      onClick={handleClick}>
      <Icon
        name={Icons.ARROW}
        width="14"
        height="19.44"
        changeViewbox={true}
        color={currentColor}
      />
    </div>
  );
}

export default AppArrowButton;
